<div class="loading-dots {{ color }} {{ size }}">
  <div class="dots">
    <div class="bounce bounce1"></div>
    <div class="bounce bounce2"></div>
    <div class="bounce bounce3"></div>
  </div>
</div>
